/* eslint-disable @typescript-eslint/no-deprecated */
import { type JSX } from 'react';

import type { QueryResult } from '@dynatrace-sdk/client-query';

import { convertToTimeseries } from './convert-to-timeseries.js';
import type { Timeseries } from '../charts/core/types/timeseries.js';

/**
 * @public
 */
export interface DQLResultConverterBaseProps {
  queryResult: QueryResult;
}

/**
 * @public
 */
export interface DQLResultConverterTimeseriesProps {
  convertTo?: 'timeseries';

  children: (data: Timeseries[]) => JSX.Element;
}

/**
 * @public
 */
export type DQLResultConverterProps = DQLResultConverterBaseProps &
  DQLResultConverterTimeseriesProps;

/**
 * Provides to timeseries converted queryResult to the children as a render prop.
 * @public
 */
export function DQLResultConverter(props: DQLResultConverterProps) {
  return props.children(
    convertToTimeseries(props.queryResult.records, props.queryResult.types),
  );
}
